import { get } from 'Api';

/**
 * Get advert to preview from api
 * @param  {String} id that belongs to the advert
 * @return {Object} advert to preview
 */
export default async function getImagePreview(id) {
  let advert = {};

  try {
    const { response, data } = await get([], `/admin/image/preview/${id}/${window.locale}`);
    if (response.ok) {
      advert = data;
    }
  } catch (ex) { /* */ }

  return advert;
}
